export default __webpack_public_path__ + "static/media/android-upgrade-preview.5cd1a9cb.png";